<div class="gridContainer tileVertrag {{odd?'c1':'c2'}}" (click)="gotoVertrag()">

    @if (!vertrag.fehlerText) {
        <!-- vollständiger Datensatz -->
        <div class="tileContainer">
            <div class="tileData">
                <div class="row">
                    <div class="cell grid-100">
                        <span class="vsnr value">{{ vertrag.vertragHandle.vsnrFormatiert }}</span>
                        <span class="label">Versicherungsscheinnummer</span>
                    </div>
                </div>
                <div class="row">
                    <div class="cell grid-50">
                        <span class="label">Kreditlinie</span> <!-- aka Bürgschaftsrahmen -->
                        <span class="value">{{ vertrag.rahmenBetrag | formatMoney }}</span>
                    </div>
                    <div class="cell grid-50">
                        <span class="label">Aktuelle Auslastung</span> <!-- aka Aktuelle Rahmenbelastung -->
                        <span class="value">{{ vertrag.rahmenBelastung | formatMoney }}</span>
                    </div>
                </div>
            </div>
            <div class="outerPercent">
                <div class="innerPercent"
                     [style.width]="vertrag.rahmenBelastung | calcPercent: vertrag.rahmenBetrag"></div>
                <div class="innerPercentFont">
                    <span class="hinweis hinweis-text">{{ vertrag.rahmenBelastung | calcPercent: vertrag.rahmenBetrag }} ausgelastet</span>
                    @if (isAuslastungWarning()) {
                        <span class="hinweis hinweis-warnung"></span>
                    }
                </div>
            </div>
        </div>
    } @else {
        <!-- kaputter Datensatz -->
        <div class="tileContainer defekt">
            <div class="ic">
                <i class="icon ico-warning"></i>
            </div>
            <div class="tileData">
                <div class="row">
                    <div class="cell grid-100">
                        <span class="vsnr value">{{ vertrag.vertragHandle.vsnrFormatiert }}</span>
                        <span class="label">Versicherungsscheinnummer</span>
                    </div>
                </div>
                <div class="row">
                    <div class="cell grid-100">
                        <span class="label">Datensatz unvollständig</span>
                        <span class="value">Vertrag kann derzeit nicht angezeigt werden</span>
                    </div>
                </div>
            </div>
            <div class="outerPercent">
                <div class="innerPercent"></div>
            </div>
        </div>
    }

</div>

